import React, {
  Fragment,
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
} from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Row, Col, Card, Tabs, Tab, Nav } from "react-bootstrap";

import { Formik } from "formik";
import * as Yup from "yup";
// import { useAuth, currentUser } from "../../../context/AuthContext";
import { db } from "../../../../firebase";
import {
  setDoc,
  getDoc,
  getDocs,
  collection,
  updateDoc,
  doc,
} from "firebase/firestore";
import {
  PatientTextInputForm,
  PatientTextInputNotRequiredForm,
  PatientDropDownForm,
} from "../PatientUtils";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../../components/toast/SetToast";
import Toast from "../../../components/toast/SetToast";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { CPAP_SIDE_EFFECT_OPTIONS } from "../../Followup/cpapFollowupSymptomUtils";

const infoData = {
  sleepStudyNumber: "",
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  age: "",
  mobile: "",
  email: "",
  startCpapDate: "",
  typeOfCpap: "",
  brand: "",
  minPressure: "",
  maxPressure: "",
  currentRampTime: "",
  humidifierSystem: "",
  averageLeak: "",
  maskType: "",
  maskSize: "",
  maskBrand: "",
  sleepTestResult: "",
  diagnosticAHI: "",
  preTreatmentEssScore: "",
  visitNumber: "",
  followupDate: "",
  followupType: "",
  cpapDataPeriod: "",
  cpapDataTotalDays: "",
  compliantDaysPct: "",
  avgUsageHours: "",
  avgAhi: "",
  pressure95Pct: "",
  maskLeakRate: "",
  assessment: "",
  essScore: "",
  wakeUpFeeling: "",
  daytimeSleepiness: "",
  problems: [],
  assessmentSummary: "",
  recommendations: "",
  nextAppointment: "",
};
const profileData = {
  username: "",
  email: "",
  titleTh: "",
  firstnameTh: "",
  lastnameTh: "",
  titleEn: "",
  firstnameEn: "",
  lastnameEn: "",
  dateOfBirth: "",
  status: "",
  ethnicity: "",
  nationality: "",
  religion: "",
  bloodType: "",
  note: "",
  gender: "",
  occupation: "",
  mobile: "",
  telephone: "",
  address1: "",
  address2: "",
  province: "",
  postcode: "",
  medicineIntolerance: "",
  healthInsurance: "",
  other: "",
  emergencyContact: "",
  relationship: "",
  emergencyContactPhone: "",
};
const cpapFollowUpData = {
  assign: false,
  formname: "แบบฟอร์มการติดตามผลการใช้เครื่องอัดอากาศแรงดันบวก",
  id: "4",
  info: infoData,
  submit: false,
};
const CPAPFollowUp = () => {
  // const profileRef = useRef(profileData);
  const demographicRef = useRef(infoData);
  const history = useHistory();
  const [patientInfo, setPatientInfo] = useState(profileData);
  const [demographicDoc, setDemographicDoc] = useState(cpapFollowUpData);
  const [isLoading, setLoading] = useState(true);
  const { id, uuid } = useParams();
  // console.log("uuid: ", uuid);
  const DropdownBox = ({
    title = "",
    htmlFor = "",
    id = "",
    name = "",
    refvalue,
    placeholder = "Please select",
    options = [""],
    defaultValue,
  }) => {
    return (
      <div className="form-group row">
        <label className="col-xl-4 col-form-label" htmlFor={htmlFor}>
          {title}
          <span className="text-danger"></span>
        </label>
        <div className="col-xl-4">
          <select
            className="form-control"
            id={id}
            name={name}
            ref={refvalue}
            defaultValue={defaultValue}
          >
            {options.map((value) => (
              <option value={value}>{value}</option>
            ))}
          </select>
        </div>
      </div>
    );
  };
  const InputBox = ({
    title = "",
    value = "",
    placeholder = "",
    id = "",
    measure = "",
    refValue,
    noBox = false,
    defaultValue,
    required,
    type = "text",
  }) => {
    return (
      <div className="form-group row">
        <label className="col-xl-4 col-form-label mt-2">{title}</label>
        <div className="col-xl-4">
          {noBox == false && (
            <input
              type={type}
              className="form-control"
              placeholder={placeholder == "" ? title : placeholder}
              id={id}
              ref={refValue}
              defaultValue={defaultValue}
              required={required}
            />
          )}
        </div>
        <div className="ml-3 mt-3">
          <text>{measure}</text>
        </div>
      </div>
    );
  };
  const InputRadio = ({
    title = "",
    id = "",
    options = [""],
    checked = "",
    name = "",
    isnote = false,
    note = "",
    mt = "row mt-3",
    refValue,
    refNote,
    required,
  }) => {
    return (
      <fieldset className="form-group">
        <div className={mt}>
          <label className="col-xl-4 col-form-label pt-0">{title}</label>
          <div className="col-xl-6">
            {options.map((value) => {
              return (
                <>
                  <div className="form-check">
                    <label className="form-check-label">
                      <input
                        className="form-check-input"
                        type="radio"
                        name={name}
                        value={value}
                        required={required}
                        // id={id}
                        onChange={(e) => {
                          demographicRef.current[refValue] = e.target.value;
                        }}
                        defaultChecked={checked == value ? "checked" : ""}
                      />
                      {value}
                    </label>
                  </div>
                </>
              );
            })}
          </div>
          {isnote && (
            <div className="form-check">
              {" "}
              <textarea
                className="form-control"
                id="val-suggestions"
                name="val-suggestions"
                rows="2"
                placeholder=""
                ref={(e) => {
                  demographicRef.current[refNote] = e;
                }}
                defaultValue={note}
              ></textarea>
            </div>
          )}
        </div>
      </fieldset>
    );
  };
  const InputCheckBox = ({
    title = "",
    id = "",
    options = [""],
    checked = [],
    name = "",
    refValue,
    mt = "row mt-3",
  }) => {
    // Convert checked to array if it's a string (comma-separated from Google Forms)
    const checkedArray = Array.isArray(checked)
      ? checked
      : typeof checked === "string" && checked.length > 0
      ? checked.split(",").map((item) => item.trim())
      : [];

    // Find values that don't match any predefined options (custom "Other" inputs)
    const otherValues = checkedArray.filter(
      (value) => value && !options.includes(value)
    );

    // Initialize ref with current checked values
    if (!demographicRef.current[refValue]) {
      demographicRef.current[refValue] = [...checkedArray];
    }

    const handleCheckboxChange = (e, value) => {
      const currentValues = demographicRef.current[refValue] || [];
      if (e.target.checked) {
        if (!currentValues.includes(value)) {
          demographicRef.current[refValue] = [...currentValues, value];
        }
      } else {
        demographicRef.current[refValue] = currentValues.filter(
          (v) => v !== value
        );
      }
    };

    return (
      <fieldset className="form-group">
        <div className={mt}>
          <label className="col-xl-4 col-form-label pt-0">{title}</label>
          <div className="col-xl-6">
            {options.map((value, index) => {
              return (
                <div className="form-check" key={`${name}-option-${index}`}>
                  <label className="form-check-label">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name={name}
                      value={value}
                      onChange={(e) => handleCheckboxChange(e, value)}
                      defaultChecked={checkedArray.includes(value)}
                    />
                    {value}
                  </label>
                </div>
              );
            })}
            {/* Display custom "Other" values from Google Forms */}
            {otherValues.length > 0 && (
              <>
                <div className="mt-2 mb-1">
                  <small className="text-muted">ข้อมูลอื่นๆ ที่ระบุ:</small>
                </div>
                {otherValues.map((value, index) => (
                  <div className="form-check" key={`${name}-other-${index}`}>
                    <label className="form-check-label">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name={name}
                        value={value}
                        onChange={(e) => handleCheckboxChange(e, value)}
                        defaultChecked={true}
                      />
                      <span className="text-info">{value}</span>
                    </label>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </fieldset>
    );
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    var info = {
      sleepStudyNumber: demographicRef.current["sleepStudyNumber"].value,
      firstName: demographicRef.current["firstName"].value,
      lastName: demographicRef.current["lastName"].value,
      dateOfBirth: demographicRef.current["dateOfBirth"].value,
      age: demographicRef.current["age"].value,
      mobile: demographicRef.current["mobile"].value,
      email: demographicRef.current["email"].value,
      startCpapDate: demographicRef.current["startCpapDate"].value,
      typeOfCpap: demographicRef.current["typeOfCpap"].value,
      brand: demographicRef.current["brand"].value,
      minPressure: demographicRef.current["minPressure"].value,
      maxPressure: demographicRef.current["maxPressure"].value,
      currentRampTime: demographicRef.current["currentRampTime"].value,
      humidifierSystem: demographicRef.current["humidifierSystem"].value,
      averageLeak: demographicRef.current["averageLeak"].value,
      maskType: demographicRef.current["maskType"].value,
      maskSize: demographicRef.current["maskSize"].value,
      maskBrand: demographicRef.current["maskBrand"].value,
      sleepTestResult: demographicRef.current["sleepTestResult"].value,
      diagnosticAHI: demographicRef.current["diagnosticAHI"].value,
      preTreatmentEssScore:
        demographicRef.current["preTreatmentEssScore"].value,
      visitNumber: demographicRef.current["visitNumber"].value,
      followupDate: demographicRef.current["followupDate"].value,
      followupType: demographicRef.current["followupType"].value,
      cpapDataPeriod: demographicRef.current["cpapDataPeriod"].value,
      cpapDataTotalDays: demographicRef.current["cpapDataTotalDays"].value,
      compliantDaysPct: demographicRef.current["compliantDaysPct"].value,
      avgUsageHours: demographicRef.current["avgUsageHours"].value,
      avgAhi: demographicRef.current["avgAhi"].value,
      pressure95Pct: demographicRef.current["pressure95Pct"].value,
      maskLeakRate: demographicRef.current["maskLeakRate"].value,
      assessment: demographicRef.current["assessment"].value,
      essScore: demographicRef.current["essScore"].value,
      wakeUpFeeling: demographicRef.current["wakeUpFeeling"].value,
      daytimeSleepiness: demographicRef.current["daytimeSleepiness"].value,
      problems: demographicRef.current["problems"] || [],
      assessmentSummary: demographicRef.current["assessmentSummary"].value,
      recommendations: demographicRef.current["recommendations"].value,
      nextAppointment: demographicRef.current["nextAppointment"].value,
    };
    // console.log("info: ", info);
    // console.log("hn: ", patientInfo.hn);
    // console.log("uuid: ", uuid);
    const ref = doc(db, "patients", patientInfo.hn, "form", uuid);
    const docSnap = await getDoc(ref);
    if (docSnap.exists()) {
      try {
        var tmpDocSnap = docSnap.data();
        tmpDocSnap.info = info;
        tmpDocSnap.submit = true;
        var dateNow = new Date();
        dateNow.setHours(dateNow.getHours() + 7);
        tmpDocSnap.updateAt = dateNow.toISOString();
        // console.log(tmpDocSnap);
        await updateDoc(ref, tmpDocSnap);
        notifyTopRight("บันทึกข้อมูลสำเร็จ");
      } catch (err) {
        notifyError("บันทึกข้อมูลผิดพลาด, ", err);
      }
    }
  };
  useEffect(async () => {
    if (patientInfo.hn != undefined && patientInfo.hn != "") {
      // console.log('patientInfo.hn: ',patientInfo.hn)
      let docColRef = doc(db, "patients", id, "form", uuid);
      let docSnapForm = await getDoc(docColRef);
      console.log(">>>" + docSnapForm.data());
      setDemographicDoc(docSnapForm.data());
      // demographicRef.current["gender"] = docSnapForm.data().info.gender;
      // demographicRef.current["dateOfBirth"] =
      //   docSnapForm.data().info.dateOfBirth;
      // demographicRef.current["age"] = docSnapForm.data().info.age;
      // demographicRef.current["weight"] = docSnapForm.data().info.weight;
      // demographicRef.current["height"] = docSnapForm.data().info.height;
      // demographicRef.current["mostWeightEver"] =
      //   docSnapForm.data().info.mostWeightEver;
      // demographicRef.current["weightFiveYearsAgo"] =
      //   docSnapForm.data().info.weightFiveYearsAgo;

      // demographicRef.current["embolism"] = docSnapForm.data().info.embolism;
      // demographicRef.current["heartattack"] =
      //   docSnapForm.data().info.heartattack;
      // demographicRef.current["highBloodPressure"] =
      //   docSnapForm.data().info.highBloodPressure;
      // demographicRef.current["bloodClots"] = docSnapForm.data().info.bloodClots;
      // demographicRef.current["diabetes"] = docSnapForm.data().info.diabetes;
      // demographicRef.current["hyperlipidemia"] =
      //   docSnapForm.data().info.hyperlipidemia;
      // demographicRef.current["kidneyDisease"] =
      //   docSnapForm.data().info.kidneyDisease;
      // demographicRef.current["fattyLiver"] = docSnapForm.data().info.fattyLiver;
      // demographicRef.current["overactiveThyroid"] =
      //   docSnapForm.data().info.overactiveThyroid;
      // demographicRef.current["underactiveThtroid"] =
      //   docSnapForm.data().info.underactiveThtroid;
      // demographicRef.current["pale"] = docSnapForm.data().info.pale;
      // demographicRef.current["ironDeficiency"] =
      //   docSnapForm.data().info.ironDeficiency;
      // demographicRef.current["thalassemia"] =
      //   docSnapForm.data().info.thalassemia;
      // demographicRef.current["asthma"] = docSnapForm.data().info.asthma;
      // demographicRef.current["emphysema"] = docSnapForm.data().info.emphysema;
      // demographicRef.current["pulmonaryHypertension"] =
      //   docSnapForm.data().info.pulmonaryHypertension;
      // demographicRef.current["parkinson"] = docSnapForm.data().info.parkinson;
      // demographicRef.current["muscleWeakness"] =
      //   docSnapForm.data().info.muscleWeakness;
      // demographicRef.current["depressed"] = docSnapForm.data().info.depressed;
      // demographicRef.current["other"] = docSnapForm.data().info.other;
      // // demographicRef.current["otherNote"] = docSnapForm.data().info.otherNote;
      // demographicRef.current["regularMedicine"] =
      //   docSnapForm.data().info.regularMedicine;

      // demographicRef.current["regularMedicineNote"] =
      //   docSnapForm.data().info.regularMedicineNote;
      // demographicRef.current["smoke"] = docSnapForm.data().info.smoke;
      // demographicRef.current["smokeTotalYear"] =
      //   docSnapForm.data().info.smokeTotalYear;
      // demographicRef.current["smokePerDay"] =
      //   docSnapForm.data().info.smokePerDay;
      // demographicRef.current["stopSmokeYear"] =
      //   docSnapForm.data().info.stopSmokeYear;
      // demographicRef.current["stopSmokeTotalYear"] =
      //   docSnapForm.data().info.stopSmokeTotalYear;
      // demographicRef.current["stopSmokePerDay"] =
      //   docSnapForm.data().info.stopSmokePerDay;
      // demographicRef.current["alc"] = docSnapForm.data().info.alc;
      // demographicRef.current["alcTotalYear"] =
      //   docSnapForm.data().info.alcTotalYear;
      // demographicRef.current["alcPerDay"] = docSnapForm.data().info.alcPerDay;
      // demographicRef.current["stopAlcYear"] =
      //   docSnapForm.data().info.stopAlcYear;
      // demographicRef.current["stopAlcTotalYear"] =
      //   docSnapForm.data().info.stopAlcTotalYear;
      // demographicRef.current["stopAlcPerDay"] =
      // docSnapForm.data().info.stopAlcPerDay;
      // demographicRef.current["coffee"] = docSnapForm.data().info.coffee;
      // demographicRef.current["coffeePerDay"] =
      //   docSnapForm.data().info.coffeePerDay;
      // demographicRef.current["coffeePerWeek"] =
      //   docSnapForm.data().info.coffeePerWeek;
      // demographicRef.current["soda"] = docSnapForm.data().info.soda;
      // demographicRef.current["sodaPerDay"] = docSnapForm.data().info.sodaPerDay;
      // demographicRef.current["sodaPerWeek"] =
      //   docSnapForm.data().info.sodaPerWeek;
      // demographicRef.current["apnea"] = docSnapForm.data().info.apnea;
      // demographicRef.current["apneaDetail"] =
      //   docSnapForm.data().info.apneaDetail;
      // demographicRef.current["snore"] = docSnapForm.data().info.snore;
      // demographicRef.current["snoreDetail"] =
      //   docSnapForm.data().info.snoreDetail;
      // demographicRef.current["unusuallySleepy"] =
      //   docSnapForm.data().info.unusuallySleepy;
      // demographicRef.current["unusuallySleepyDetail"] =
      //   docSnapForm.data().info.unusuallySleepyDetail;
      // demographicRef.current["insomnia"] = docSnapForm.data().info.insomnia;
      // demographicRef.current["insomniaDetail"] =
      //   docSnapForm.data().info.insomniaDetail;

      setLoading(false);

      return;
    }

    const ref = await doc(db, "patients", id);
    const docSnap = await getDoc(ref);
    setPatientInfo(docSnap.data());
  }, [patientInfo]);
  console.log(demographicDoc);

  return (
    <Fragment>
      <Toast />

      <Col xl={12}>
        <Card>
          <Card.Header>
            <Card.Title>การติดตามผลการใช้เครื่องอัดอากาศแรงดันบวก</Card.Title>
          </Card.Header>
          <Card.Body>
            {!isLoading ? (
              <div className="basic-form">
                <form onSubmit={submitHandler}>
                  <div className="row">
                    <div className="col-xl-7">
                      <h4 className="mb-4">
                        <b>ข้อมูลทั่วไปและข้อมูลพื้นฐานการรักษา</b>
                      </h4>
                      <InputBox
                        title="Sleep Study Number"
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["sleepStudyNumber"] = el)
                        }
                        defaultValue={demographicDoc.info.sleepStudyNumber}
                        required={true}
                      ></InputBox>
                      <InputBox
                        title="ชื่อ"
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["firstName"] = el)
                        }
                        defaultValue={demographicDoc.info.firstName}
                        required={true}
                      ></InputBox>
                      <InputBox
                        title="นามสกุล"
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["lastName"] = el)
                        }
                        defaultValue={demographicDoc.info.lastName}
                        required={true}
                      ></InputBox>
                      <InputBox
                        title="วันเกิด"
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["dateOfBirth"] = el)
                        }
                        defaultValue={demographicDoc.info.dateOfBirth}
                        type="date"
                      ></InputBox>
                      <InputBox
                        title="อายุ"
                        measure="ปี"
                        refValue={(el) => (demographicRef.current["age"] = el)}
                        defaultValue={demographicDoc.info.age}
                        required={true}
                      ></InputBox>
                      <InputBox
                        title="เบอร์โทร"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["mobile"] = el)
                        }
                        defaultValue={demographicDoc.info.mobile}
                      ></InputBox>
                      <InputBox
                        title="อีเมล์"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["email"] = el)
                        }
                        defaultValue={demographicDoc.info.email}
                      ></InputBox>
                      <InputBox
                        title="วันที่เริ่มใช้งานเครื่อง CPAP"
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["startCpapDate"] = el)
                        }
                        defaultValue={demographicDoc.info.startCpapDate}
                        type="date"
                      ></InputBox>
                      <InputRadio
                        title="ประเภทเครื่อง"
                        required={true}
                        options={["CPAP", "Auto-CPAP", "BiPAP"]}
                        name="ประเภทเครื่อง"
                        checked={demographicDoc.info.typeOfCpap}
                        refValue={"typeOfCpap"}
                      ></InputRadio>
                      <InputBox
                        title="ยี่ห้อ/แบรนด์"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["brand"] = el)
                        }
                        defaultValue={demographicDoc.info.brand}
                      ></InputBox>
                      <h4 className="mt-5 mb-4">
                        <b>การตั้งค่าความดัน/Presure Setting (cmH2O)</b>
                      </h4>{" "}
                      <InputBox
                        title="Min Pressure (cmH2O)"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["minPressure"] = el)
                        }
                        defaultValue={demographicDoc.info.minPressure}
                      ></InputBox>
                      <InputBox
                        title="Max Pressure (cmH2O)"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["maxPressure"] = el)
                        }
                        defaultValue={demographicDoc.info.maxPressure}
                      ></InputBox>
                      <InputBox
                        title="Current Ramp Time (cmH2O)"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["currentRampTime"] = el)
                        }
                        defaultValue={demographicDoc.info.currentRampTime}
                      ></InputBox>
                      <InputBox
                        title="Humidifier System"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["humidifierSystem"] = el)
                        }
                        defaultValue={demographicDoc.info.humidifierSystem}
                      ></InputBox>
                      <InputBox
                        title="Average Leak"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["averageLeak"] = el)
                        }
                        defaultValue={demographicDoc.info.averageLeak}
                      ></InputBox>
                      <InputRadio
                        title="Mask Type"
                        required={true}
                        options={["Nasal", "Nasal Pillow", "Full Face"]}
                        name="Mask Type"
                        checked={demographicDoc.info.maskType}
                        refValue={"maskType"}
                      ></InputRadio>
                      <InputBox
                        title="Mask Size"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["maskSize"] = el)
                        }
                        defaultValue={demographicDoc.info.maskSize}
                      ></InputBox>
                      <InputBox
                        title="หน้ากากยี่ห้อ/รุ่น"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["maskBrand"] = el)
                        }
                        defaultValue={demographicDoc.info.maskBrand}
                      ></InputBox>
                      <InputBox
                        title="ผลการวินิจฉัย Sleep Test"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["sleepTestResult"] = el)
                        }
                        defaultValue={demographicDoc.info.sleepTestResult}
                      ></InputBox>
                      <InputBox
                        title="AHI ก่อนการรักษา/Diagnostic AHI"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["diagnosticAHI"] = el)
                        }
                        defaultValue={demographicDoc.info.diagnosticAHI}
                      ></InputBox>
                      <InputBox
                        title="ESS ก่อนการรักษา (คะแนน)/Epworth Sleepiness Scale"
                        measure=""
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["preTreatmentEssScore"] = el)
                        }
                        defaultValue={demographicDoc.info.preTreatmentEssScore}
                      ></InputBox>
                    </div>
                    <div className="col-xl-7">
                      <h4 className="mb-4">
                        <b>
                          บันทึกการติดตามผลรายครั้ง (Per-Visit Follow-up Log)
                        </b>
                      </h4>{" "}
                      <InputBox
                        title="ครั้ง (Visit No.)"
                        placeholder="ครั้ง (Visit No.)"
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["visitNumber"] = el)
                        }
                        defaultValue={demographicDoc.info.visitNumber}
                      ></InputBox>
                      <InputBox
                        title="วันที่ติดตาม (Date)"
                        required={true}
                        refValue={(el) =>
                          (demographicRef.current["followupDate"] = el)
                        }
                        defaultValue={demographicDoc.info.followupDate}
                        type="date"
                      ></InputBox>
                      <InputRadio
                        title="รูปแบบ"
                        required={true}
                        options={["OPD", "โทรศัพท์"]}
                        name="รูปแบบ"
                        checked={demographicDoc.info.followupType}
                        refValue={"followupType"}
                      ></InputRadio>
                      <h4 className="mb-4">
                        <b>ข้อมูลจากเครื่อง (Objective Data)</b>
                      </h4>{" "}
                      <InputBox
                        title="ช่วงข้อมูล (Data Period)"
                        placeholder="ช่วงข้อมูล (Data Period)"
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["cpapDataPeriod"] = el)
                        }
                        defaultValue={demographicDoc.info.cpapDataPeriod}
                      ></InputBox>
                      <InputBox
                        title="รวมกี่วัน"
                        placeholder="รวมกี่วัน"
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["cpapDataTotalDays"] = el)
                        }
                        defaultValue={demographicDoc.info.cpapDataTotalDays}
                      ></InputBox>
                      <h4 className="mb-4">
                        <b>ความร่วมมือในการใช้(Adherence)</b>
                      </h4>{" "}
                      <InputBox
                        title="% ของวันที่ใช้งาน > 4 ชม."
                        placeholder=""
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["compliantDaysPct"] = el)
                        }
                        defaultValue={demographicDoc.info.compliantDaysPct}
                      ></InputBox>
                      <InputBox
                        title="ชั่วโมงใช้งานเฉลี่ยนต่อคืน (ชั่วโมง)"
                        placeholder=""
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["avgUsageHours"] = el)
                        }
                        defaultValue={demographicDoc.info.avgUsageHours}
                      ></InputBox>
                      <h4 className="mb-4">
                        <b>ประสิทธิภาพการรักษา (Efficacy)</b>
                      </h4>{" "}
                      <InputBox
                        title="ดัชนี AHI เฉลี่ย ครั้ง/ชม."
                        placeholder=""
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["avgAhi"] = el)
                        }
                        defaultValue={demographicDoc.info.avgAhi}
                      ></InputBox>
                      <InputBox
                        title="แรงดัน 95% (สำหรับ APAP) cmH2O"
                        placeholder=""
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["pressure95Pct"] = el)
                        }
                        defaultValue={demographicDoc.info.pressure95Pct}
                      ></InputBox>
                      <h4 className="mb-4">
                        <b>การรั้วของหน้ากาก (Mask Leak)</b>
                      </h4>{" "}
                      <InputBox
                        title="อัตราการรั่วเฉลี่ย (Leak Rate) L/min"
                        placeholder=""
                        measure="้"
                        refValue={(el) =>
                          (demographicRef.current["maskLeakRate"] = el)
                        }
                        defaultValue={demographicDoc.info.maskLeakRate}
                      ></InputBox>
                      <InputRadio
                        title="การประเมิน"
                        required={true}
                        options={["อยู่ในเกณฑ์ดี", "สูง ควรได้รับการแก้ไข"]}
                        name="การประเมิน"
                        checked={demographicDoc.info.assessment}
                        refValue={"assessment"}
                      ></InputRadio>
                      <h4 className="mb-4">
                        <b>ข้อมูลจากการซักถามผู้ป่วย</b>
                      </h4>{" "}
                      <InputBox
                        title="คะแนนความง่วง (Epworth Sleepiness Scale - ESS)"
                        placeholder=""
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["essScore"] = el)
                        }
                        defaultValue={demographicDoc.info.essScore}
                      ></InputBox>
                      <h4 className="mb-4">
                        <b>อาการโดยรวม (Overrall Symptoms)</b>
                      </h4>{" "}
                      <InputRadio
                        title="ความรู้สึกหลังตื่นนอน"
                        required={true}
                        options={[
                          "สดชื่นขึ้นมาก",
                          "สดชื่นขึ้น",
                          "เหมือนเดิม",
                          "แย่ลง",
                        ]}
                        name="ความรู้สึกหลังตื่นนอน"
                        checked={demographicDoc.info.wakeUpFeeling}
                        refValue={"wakeUpFeeling"}
                      ></InputRadio>
                      <InputRadio
                        title="อาการง่วงนอนตอนกลางวัน"
                        required={true}
                        options={["ดีขึ้นมาก", "ดีขึ้น", "เหมือนเดิม", "แย่ลง"]}
                        name="อาการง่วงนอนตอนกลางวัน"
                        checked={demographicDoc.info.daytimeSleepiness}
                        refValue={"daytimeSleepiness"}
                      ></InputRadio>
                      <InputCheckBox
                        title="ปัญหาและข้างเคียงที่พบ (Problems & Side Effects)"
                        required={true}
                        options={CPAP_SIDE_EFFECT_OPTIONS}
                        name="ปัญหาและข้างเคียงที่พบ (Problems & Side Effects)"
                        checked={demographicDoc.info.problems}
                        refValue={"problems"}
                      ></InputCheckBox>
                      <h4 className="mb-4">
                        <b>การประเมินและแผนการดูแล</b>
                      </h4>{" "}
                      <InputBox
                        title="สรุปการประเมิน"
                        placeholder=""
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["assessmentSummary"] = el)
                        }
                        defaultValue={demographicDoc.info.assessmentSummary}
                      ></InputBox>
                      <InputBox
                        title="การดำเนินการ/คำแนะนำที่ให้"
                        placeholder=""
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["recommendations"] = el)
                        }
                        defaultValue={demographicDoc.info.recommendations}
                      ></InputBox>
                      <InputBox
                        title="นัดหมายครั้งต่อไป"
                        placeholder=""
                        measure=""
                        refValue={(el) =>
                          (demographicRef.current["nextAppointment"] = el)
                        }
                        defaultValue={demographicDoc.info.nextAppointment}
                      ></InputBox>
                    </div>
                  </div>

                  <div className="form-group row">
                    <div className="col-sm-10">
                      <button type="submit" className="btn btn-primary">
                        บันทึกข้อมูล
                      </button>
                      <button
                        onClick={() => {
                          history.push(`/patient-page/${id}`);
                        }}
                        type="submit"
                        className="btn btn-light ml-2"
                      >
                        ยกเลิก
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            ) : (
              <></>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Fragment>
  );
};

export default CPAPFollowUp;
